import Skeleton from "@mui/material/Skeleton";

// ten sam layout co ArticleView, żeby po załadowaniu nic nie skakało
export function ArticleSearchItemSkeleton() {
	return (
		<div className="article-search-item">
			<Skeleton variant="rounded" className="article-search-item__icon" />
			<div className="flex flex-col gap-4 min-w-0 flex-1">
				<Skeleton variant="text" width="45%" height={22} />
				<Skeleton variant="text" width={120} height={16} />
			</div>
		</div>
	);
}
